export function AdaltraTubes({ className = "" }) {
  return <div aria-hidden="true" className={`adl-tubes ${className}`}><i /><i /><i /></div>;
}
